import { render, staticRenderFns } from "./ChildGender.vue?vue&type=template&id=8ed95580&scoped=true&"
import script from "./ChildGender.vue?vue&type=script&lang=js&"
export * from "./ChildGender.vue?vue&type=script&lang=js&"
import style0 from "./ChildGender.vue?vue&type=style&index=0&id=8ed95580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed95580",
  null
  
)

export default component.exports